import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { TestsBySection } from "../../../models/TestsBySection";

type Props = {
	onEdit: (row: TestsBySection) => void;
	onDelete: (row: TestsBySection) => void;
};

export const useTestsBySectionOptionsFunctions = ({
	onEdit,
	onDelete,
}: Props) => {
	const getMenuOptions = (data: TestsBySection | any) => {
		let options: MenuOptionType[] = [];
		if (data) {
			options = options.concat([
				{
					name: "Edit",
					key: "edit_tests_by_section",
					onClick: () => onEdit(data),
					icon: <EditIcon />,
				},
				{
					name: "Delete",
					key: "delete_tests_by_section",
					onClick: () => onDelete(data),
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
